import React, { useState } from "react";

export default function Loader({ state }) {
  return (
    <>
      {state && (
        <div className="wait-loader">
          <i className="fa fa-spinner fa-spin green"></i>
        </div>
      )}
    </>
  );
}
